<template>
  <app-content>
    <div id="countdown-placeholder"></div>
    <countdown/>
    <main>
      <parallax-section :index="1" alt="Hände mit Ring" :speed="0.3" height="43vw"
                        max-height="70vh"/>

      <page-section id="welcome" title="Herzlich willkommen!">
        <p>
          Herzlich willkommen unserer Hochzeitswebsite! Hier kannst du dir Fotos (und bald auch
          Videos) von der Feier anschauen und so noch einmal diesen schönen Tag revue passieren
          lassen. Außerdem würden wir uns freuen, wenn du uns Fotos zur Verfügung stellst, die du
          selbst an diesem Tag gemacht hast. Folgendes kannst du hier tun:
        </p>
        <ul>
          <li>Du kannst die Fotos der Hochzeit in der
            <router-link to="/galerie">Galerie</router-link> ansehen</li>
          <li>Du kannst deine eigenen Fotos <router-link to="/upload">hochladen</router-link></li>

        </ul>
        <p>
          <strong>Danke</strong>, dass DU Teil dieses wunderschönen Wochenendes warst. Wir fühlen
          uns wahnsinnig beschenkt von eurer Anwesenheit, eurem persönlichen Einsatz und eurer
          Freundschaft. Ohne euch wäre unsere Hochzeit nicht halb so schön geworden. Wir hoffen,
          dass es euch auch so sehr gefallen hat und dass ihr mit den Fotos noch einmal in diesen
          Tag eintauchen könnt.
        </p>
      </page-section>
    </main>
  </app-content>
</template>

<script>
// @ is an alias to /src
import PageSection from '@/components/PageSection.vue';
import ParallaxSection from '@/components/ParallaxSection.vue';

import Countdown from '@/components/Countdown.vue';
import AppContent from '@/components/technical/AppContent.vue';

export default {
  name: 'Home',
  components: {
    AppContent,

    PageSection,
    ParallaxSection,

    Countdown,
  },

  mounted() {
    if (this.$route.hash) {
      const targetEl = document.querySelector(this.$route.hash);

      if (targetEl) {
        const targetTop = targetEl.offsetTop;
        window.scrollTo({
          top: targetTop,
          behavior: 'smooth',
        });
      }
    }
  },
};
</script>

<style scoped lang="scss">
  @import "../scss/variables";

  p, ul {
    font-size: 1.25rem;

    &:last-child {
      margin-bottom: 0;
    }
  }

  #countdown-placeholder {
    padding-top: $hero-size-xs - $titlebar-placeholder-sm - $titlebar-size-sm;

    @media only screen and (min-width: $breakpoint-sm) {
      padding-top: $hero-size-sm - $titlebar-placeholder-sm - $titlebar-size-sm;
    }

    @media only screen and (min-width: $breakpoint-md) {
      padding-top: $hero-size-md - $titlebar-placeholder-md - $titlebar-size-md;
    }

    @media only screen and (min-width: $breakpoint-lg) {
      padding-top: $hero-size-lg - $titlebar-placeholder-md - $titlebar-size-md;
    }

    @media only screen and (min-width: $breakpoint-xl) {
      padding-top: $hero-size-xl - $titlebar-placeholder-md - $titlebar-size-md;
    }

    @media only screen and (min-width: $breakpoint-xxl) {
      padding-top: $hero-size-xxl - $titlebar-placeholder-md - $titlebar-size-md;
    }

    @media only screen and (min-width: $breakpoint-xxxl) {
      padding-top: $hero-size-xxxl - $titlebar-placeholder-md - $titlebar-size-md;
    }
  }

  main {
    z-index: 10;

    section {
      padding: 1.75rem;

      @media only screen and (min-width: $breakpoint-md) {
        padding: 2rem;
      }

      @media only screen and (min-width: $breakpoint-lg) {
        padding: 2.5rem;
      }
    }

    #welcome {
      text-align: left;
      font-size: 0.75rem;
    }
  }
</style>
